/**
 * Canonical compatibility URL ownership shared by the app, static exporter,
 * and serve-time HTML enrichment. Pair order is URL identity, not display
 * order: every producer must link the lexically sorted route.
 */

export type CompatibilityLocale = "en" | "hi";

export function canonicalCompatibilityPair(aId: string, bId: string): string {
  return [aId, bId].sort().join("-");
}

export function canonicalCompatibilityPath(
  aId: string,
  bId: string,
  locale: CompatibilityLocale = "en"
): string {
  const prefix = locale === "hi" ? "/hi/compatibility" : "/compatibility";
  return `${prefix}/${canonicalCompatibilityPair(aId, bId)}/`;
}
